import React from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux'; // eslint-disable-line no-unused-vars
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import common from '~/common';
import Third from './Third';

class Second extends React.Component {
  state={ more: false, height: '0px', maxHeight: 0, over: false }
  _clickMoreBtn=() => {
    const { data, history, firstPath } = this.props;
    const haveDetail = data.detail.length > 0;

    if (haveDetail) {
      this.setState({ more: !this.state.more });
      const { more } = this.state;
      if (more) {
        clearInterval(this.timer);
        this.setState({ height: '0px', maxHeight: 0 });
      } else {
        this.timer = setInterval(() => {
          const { maxHeight } = this.state;
          if (maxHeight < 10000) this.setState({ height: 'auto', maxHeight: maxHeight + 5 });
          else clearInterval(this.timer);
        }, 5);
      }
    } else history.push(`${common.rootPath}/Manage/Main/${firstPath}/${data.path}`);
  }

  render () {
    const { data, history, firstPath, pathAry = [] } = this.props;
    const { more, height, maxHeight, over } = this.state;
    const haveDetail = data.detail.length > 0;
    const isCurrent = history.location.pathname.match(`${common.rootPath}/Manage/Main/${firstPath}/${data.path}/`) || history.location.pathname === (`${common.rootPath}/Manage/Main/${firstPath}/${data.path}`); ;

    return (
      <div>
        <div style={{ display: 'flex', paddingBottom: 8, paddingTop: 8, paddingRight: 8, paddingLeft: 12, cursor: 'pointer', backgroundColor: over ? '#a8a8a8' : '#F2F2F2' }} onClick={this._clickMoreBtn} onMouseOver={() => this.setState({ over: true })} onMouseOut={() => this.setState({ over: false })}>
          <data.icon style={{ color: '#064B6F', height: 24, width: 24 }} />
          <div style={{ marginLeft: 8, flex: 1 }}>
            <div style={{ maxWidth: '100%', fontSize: 16, lineHeight: '24px', letterSpacing: '0.15%', marginLeft: 10, color: isCurrent ? '#064B6F' : 'black', textAlign: 'start' }}>{data.text}</div>
          </div>
          {haveDetail && (
            <div style={{ height: 24, display: 'flex', alignItems: 'center' }}>
              {!more && <ExpandMore style={{ color: '#064B6F', height: 18, width: 18 }} />}
              {more && <ExpandLess style={{ color: '#064B6F', height: 18, width: 18 }} />}
            </div>
          )}
        </div>
        <div style={{ height: 1, backgroundColor: '#979797' }} />
        <div style={{ width: '100%', height, maxHeight, overflow: 'hidden' }}>
          {
            data.detail.map((o, i) => {
              if (pathAry.indexOf(o.path) > -1) { return <Third key={i} data={o} firstPath={firstPath} secondPath={data.path} />; } else return null;
            })
          }
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  pathAry: state.data.PathAry,
});
const mapDispatchToProps = dispatch => ({
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Second));
